/*
 * @Author: zj 
 * @Date: 2019-04-17 11:13:18 
 * @Last Modified by: shenlurong
 * @Last Modified time: 2020-09-16 18:39:44
 */
// 此模块会使用seeion 缓存
const app = {
    state: {
        userInfo: '',
        token: '',
        indexNavAft: '',
        companyInfo: '',
        departmentInfo: '',
        rootDepartment: '',
        userDetileInfo: '',
        myTaskId: {
            id: '',
            name: ''
        },
        reportDetail: '', //问题详情ID
        statusAll: function() {
            var v = '0:问题待审核、1:问题退回、3:待处理、4:待处理、5:被放弃、6:处理中、7:待评价、8:已评价、9:评价待审核、10:待SQE确认、11:D1待审核、12:D2待审核、13:D3待审核、14:D4待审核、15:D5待审核、16:D6待审核、17:D7待审核、18:D8待审核、19:审核通过、20:审核退回、31:D1待审核、32:D2待审核、33:D3待审核、34:D4待审核、35:D5待审核、36:D6待审核、37:D7待审核、38:D8待审核、41:D1审核退回、42:D2审核退回、43:D3审核退回、44:D4审核退回、45:D5审核退回、46:D6审核退回、47:D7审核退回、48:D8审核退回、49:报告待审核、50:D8完成、51:D8完成、52:处理中、53:待处理、54:D4完成、55:待报告审核';
            var initv = v.split('、');
            var newv = [];
            for (var i in initv) {
                newv.push({
                    k: initv[i].split(':')[0],
                    v: initv[i].split(':')[1],
                })
            }


            return newv;
        }(),
        statusPart: function() {
            var v = '0:问题待审核、1:问题退回、4:待处理、5:被放弃、6:处理中、7:待评价、8:已评价、11:D1待审核、12:D2待审核、13:D3待审核、14:D4待审核、15:D5待审核、16:D6待审核、17:D7待审核、18:D8待审核';
            var initv = v.split('、');
            var newv = [];
            for (var i in initv) {
                newv.push({
                    k: initv[i].split(':')[0],
                    v: initv[i].split(':')[1],
                })
            }
            return newv;
        }(),
        aftPath: '',
        isExistCompany: '',
        scrollMain: true,
        taskDetile: false, //问题详情的返回
        searchMembers: '',
        corpId: '',

    },
    mutations: {
        setUserInfo: function(state, v) {
            state.userInfo = v;
        },
        setToken: function(state, v) {
            state.token = v;
        },
        setIndexNavAft: function(state, v) {
            state.indexNavAft = v;
        },
        setCompanyInfo: function(state, v) {
            state.companyInfo = v;
        },
        setDepartmentInfo: function(state, v) {
            state.departmentInfo = v;
        },
        setRootDepartment: function(state, v) {
            state.rootDepartment = v;
        },
        setUserDetileInfo: function(state, v) {
            state.userDetileInfo = v;
        },
        setMyTaskId: function(state, v) {
            state.myTaskId = v;
        },
        setReportDetail: function(state, v) {
            state.reportDetail = v;
        },
        setIsExistCompany: function(state, v) {
            state.isExistCompany = v;
        },
        setScrollMain: function(state, v) {
            state.scrollMain = v;
        },
        setTaskDetile: function(state, v) {
            state.taskDetile = v;
        },
        setSearchMembers: function(state, v) {
            state.searchMembers = v;
        },
        setCorpId: function(state, v) {
            state.corpId = v;
        }
    },
    actions: {
        setUserInfoFun: function(context, v) {
            context.commit('setUserInfo', v)
        },
        setTokenFun: function(context, v) {
            context.commit('setToken', v)
        },
        setIndexNavAftFun: function(context, v) {
            context.commit('setIndexNavAft', v)
        },
        setCompanyInfoFun: function(context, v) {
            context.commit('setCompanyInfo', v)
        },
        setDepartmentInfoFun: function(context, v) {
            context.commit('setDepartmentInfo', v)
        },
        setRootDepartmentFun: function(context, v) {
            context.commit('setRootDepartment', v)
        },
        setUserDetileInfoFun: function(context, v) {
            context.commit('setUserDetileInfo', v)
        },
        setMyTaskIdFun: function(context, v) {
            context.commit('setMyTaskId', v)
        },
        setReportDetailFun: function(context, v) {
            context.commit('setReportDetail', v)
        },
        setIsExistCompanyFun: function(context, v) {
            context.commit('setIsExistCompany', v)
        },
        setScrollMainFun: function(context, v) {
            context.commit('setScrollMain', v)
        },
        setTaskDetileFun: function(context, v) {
            context.commit('setTaskDetile', v)
        },
        setSearchMembersFun: function(context, v) {
            context.commit('setSearchMembers', v)
        },
        setCorpIdFun: function(context, v) {
            context.commit('setCorpId', v)
        }
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js